import React, { useState, useEffect } from 'react';

export default function SplashScreen({ onDone }) {
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFading(true), 3600);
    const doneTimer = setTimeout(() => onDone(), 4000);
    return () => { clearTimeout(fadeTimer); clearTimeout(doneTimer); };
  }, []);

  return (
    <div
      className="fixed inset-0 z-[9999] bg-black overflow-hidden"
      style={{ transition: 'opacity 0.4s ease', opacity: fading ? 0 : 1 }}
    >
      <img
        src="/fridave-splash.jpg"
        alt="FriDave Super Series"
        className="w-full h-full object-cover object-top"
      />
      {/* Subtle gradient so text reads against the sky */}
      <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, rgba(0,0,0,0.35) 0%, rgba(0,0,0,0.1) 30%, rgba(0,0,0,0) 60%)' }} />
      <div className="absolute top-[72px] left-0 right-0 flex flex-col items-center text-center">
        <div style={{ fontStyle: 'italic', fontWeight: 900, fontSize: '52px', lineHeight: 1, background: 'linear-gradient(to bottom, #C9900A, #7A4F00)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.4))' }}>FriDave's</div>
        <div style={{ fontStyle: 'italic', fontWeight: 900, fontSize: '38px', lineHeight: 1.1, background: 'linear-gradient(to bottom, #C9900A, #7A4F00)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.4))' }}>Super Series</div>
      </div>
    </div>
  );
}
